import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {SubResourceList} from "../Common/SubResourceList";
import {ListPlain} from "../amazonperformance/List";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index &&
            <SubResourceList recordType={'channel'} Component={ListPlain} {...other}/>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

export const PerformanceTab = (props) => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label="A to Z Claims" {...a11yProps(0)} />
                <Tab label="Chargeback Claims" {...a11yProps(1)} />
                <Tab label="Negative Feedbacks" {...a11yProps(2)} />
                <Tab label="Product Safety" {...a11yProps(3)} />
                <Tab label="Authenticity" {...a11yProps(4)} />
                <Tab label="IP Complaints" {...a11yProps(5)} />
                <Tab label="Listing Violations" {...a11yProps(6)} />
            </Tabs>
            <TabPanel value={value} index={0} filter={{ type: 'aToz' }} {...props}/>
            <TabPanel value={value} index={1} filter={{ type: 'chargeback' }} {...props}/>
            <TabPanel value={value} index={2} filter={{ type: 'negativefeedback' }} {...props}/>
            <TabPanel value={value} index={3} filter={{ type: 'productSafetyData' }} {...props}/>
            <TabPanel value={value} index={4} filter={{ type: 'productAuthenticityData' }} {...props}/>
            <TabPanel value={value} index={5} filter={{ type: 'intellectualpropertydata' }} {...props}/>
            <TabPanel value={value} index={6} filter={{ type: 'listingPolicydata' }} {...props}/>
        </div>
    );
}
